import { v4 } from 'uuid';

import Configuration from '~/services/configuration';
import { Uuid } from '~/types/Uuid';

import { AgentMessage } from './types';

export const createStreamingMessage = (
  agentExecutionId: string,
): AgentMessage => ({
  id: v4(),
  agentExecutionId: agentExecutionId,
  userType: 'other',
  text: '',
  messageContext: null,
  timestamp: new Date(),
  sources: [],
  citations: [],
  feedbackDetails: undefined,
});

const camelizeEventType = (eventType: string): string => {
  return eventType.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

export const getHandlerName = (eventType: string): string => {
  const camelized = camelizeEventType(eventType);
  return `on${camelized.charAt(0).toUpperCase()}${camelized.slice(1)}`;
};

export const getStreamEndpoint = (id: Uuid) =>
  `${Configuration.sylvanusEndpoint}/api/v1/agent-execution/${id}/ai-message/stream`;

export type StreamEvent = {
  eventType?: string;
  text?: string | null;
  message?: { message_text?: string | null } | null;
};

const ERROR_PREFIX = 'ERROR:';

export const isStreamEnd = (event: StreamEvent, eventName?: string) =>
  eventName === 'stream_end' || event.eventType === 'stream_end';

/** Live runs send the result on message_end, a replay after the run finished sends it on message. */
export const isResultEvent = (event: StreamEvent) =>
  event.eventType === 'message_end' || event.eventType === 'message';

/** The server error text a stream_end event carries after the ERROR: prefix. */
export const getStreamErrorText = (event: StreamEvent) =>
  event.text?.startsWith(ERROR_PREFIX)
    ? event.text.slice(ERROR_PREFIX.length).trim()
    : undefined;

export const parseJson = (text?: string | null): unknown => {
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
};
